import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useTranslation } from 'react-i18next'

const words = ['Opus', 'Magnum', 'Ghost']

export default function Preloader({ onComplete }) {
  const { t } = useTranslation()
  const isReturnVisit = sessionStorage.getItem('omg_visited')
  const [visible, setVisible] = useState(!isReturnVisit)

  useEffect(() => {
    // Remove the instant HTML preloader now that React has loaded
    const ip = document.getElementById('instant-preloader')
    if (ip) ip.remove()

    if (isReturnVisit) {
      onComplete()
      return
    }
    sessionStorage.setItem('omg_visited', '1')
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (prefersReduced) {
      setVisible(false)
      const timer = setTimeout(onComplete, 200)
      return () => clearTimeout(timer)
    }
    const timer = setTimeout(() => {
      setVisible(false)
      setTimeout(onComplete, 1000)
    }, 2200)
    return () => clearTimeout(timer)
  }, [onComplete])

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="preloader"
          role="status"
          aria-live="polite"
          exit={{
            clipPath: 'inset(50% 0 50% 0)',
          }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          style={{ background: 'radial-gradient(circle at 50% 50%, #111 0%, #0a0a0a 70%)' }}
        >
          <div className="preloader-inner">
            <div className="preloader-logo">
              {words.map((word, i) => (
                <motion.span
                  key={i}
                  initial={{ opacity: 0, y: 50, filter: 'blur(10px)' }}
                  animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
                  exit={{ opacity: 0, y: -60, scale: 1.5, filter: 'blur(12px)' }}
                  transition={{
                    duration: 0.9,
                    delay: 0.2 + i * 0.2,
                    ease: [0.33, 1, 0.68, 1],
                    exit: { duration: 0.5, delay: i * 0.08 },
                  }}
                  className="preloader-word"
                >
                  {word}
                </motion.span>
              ))}
            </div>

            <motion.div
              className="preloader-line"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.4, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
            />

            <motion.p
              className="preloader-tagline"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.8, delay: 1.2 }}
            >
              {t('preloader.tagline')}
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
